export const RESOURCE_MENU_WIDTH = 358;
